<template>
  <section class="card_main">
    <section class="card_box" v-for="(cardItem,cardIndex) in cardList" :key="cardItem+cardIndex">
      <img
        @click.stop="delectCardItem(cardIndex)"
        class="delect_icon"
        v-if="cardIndex > 0 && come != 'xuqian'"
        src="../../../assets/images/delete_red.png"
      />
      <section class="mess_list">
        <section :class="$store.state.common.theme !=3 ? 'mess_list_item' :'mess_list_item mess_list_item_3'">
          <p class="list_item_left">
            车牌号
            <span>*</span>
          </p>
          <p
            :class="['list_item_right',!cardItem.cardNumber?'placeholder':'',come == 'xuqian'?'notclick':'']"
            @click="showKeyBoard(cardIndex)"
          >{{!cardItem.cardNumber?'请输入车牌号':cardItem.cardNumber}}</p>
          <!-- <input class="list_item_right" type="text" v-model="cardNumber" placeholder="请输入车牌号"> -->
        </section>
      </section>
      <!-- <h4 v-if="showUpLoadImg">
        上传照片
        <span v-if="mustImg != 2">*</span>
      </h4>
      <p
        v-if="showUpLoadImg"
        class="tips"
      >{{mustImg != 2?"请务必上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料。":"上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料，可提高申请通过成功率哦~"}}</p>
      <div class="pic">
        <div class="addPic" v-for="(imgItem,imgIndex) in cardItem.fileList" :key="imgItem.path">
          <img class="video" :src="imgItem.path" @click="viewImage(imgItem,cardIndex,imgIndex)" />
          <img
            class="deleteFile"
            v-if="come != 'xuqian'"
            @click.stop="deleteFile(imgItem,cardIndex,imgIndex)"
            src="../../../assets/images/btn_clear.png"
          />
        </div>
        <div class="addPic" v-if="come != 'xuqian' && cardItem.fileList.length<9">
          <img class="addImg" src="../../../assets/images/repair/add.png" />
          <div class="item_center_inp" style="opacity:0;">
            <uploadimg-spaceup
              :multiple="true"
              :targetId="cardItem.targetId"
              :fileList="cardItem.fileList"
              moduleCode="TCP"
              @uploadImgEnd="uploadImgEnd"
              :index="cardIndex"
            ></uploadimg-spaceup>
          </div>
        </div>
      </div> -->
    </section>
    <!-- 添加车牌 -->
    <section
      class="add_card"
      v-if="come != 'add' && cardList.length < parkingMess.maxPlateNum && come != 'xuqian' &&serverType!=2 && parkingMess.id != 8 && parkingMess.id != 9"
    >
      <section class="add_card_main" @click="addCardNumber">
        <img :src="require(`../../../assets/images/btn_add_${$store.state.common.theme}.png`)" />
        <span>添加车牌</span>
      </section>
    </section>
    <!-- 附件 -->
     <div class="image_box" v-if="come !='add'">
       <div class="card_felx"></div>
        <h4  v-if="showUpLoadImg">
          上传照片
          <span v-if="mustImg != 2">*</span>
        </h4>
        <p
          v-if="showUpLoadImg"
          class="tips"
        >{{mustImg != 2?"请务必上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料。":"上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料，可提高申请通过成功率哦~"}}</p>
        <div class="pic">
          <div class="addPic" v-for="(imgItem,imgIndex) in cardfileList" :key="imgItem.path">
            <img class="video" :src="imgItem.path" @click="viewImage(imgItem,cardIndex,imgIndex)" />
            <img
              class="deleteFile"
              v-if="come != 'xuqian'"
              @click.stop="deleteFile(imgItem,cardIndex,imgIndex)"
              src="../../../assets/images/btn_clear.png"
            />
          </div>
          <div class="addPic" v-if="come != 'xuqian' && cardfileList.length<9">
            <img class="addImg" src="../../../assets/images/repair/add.png" />
            <div class="item_center_inp" style="opacity:0;">
              <uploadimg-spaceup
                :multiple="true"
                :targetId="oldTargetId"
                :fileList="cardfileList"
                moduleCode="TCP"
                @uploadImgEnd="uploadImgEnd"
                :index="0"
              ></uploadimg-spaceup>
            </div>
          </div>
        </div>
        <div class="card_felx1"></div>
     </div>


    
   
    <!-- 键盘 -->
    <mt-popup v-model="showPopup" position="bottom" class="mint-popup">
      <key-board
        @sure="sureCardNumber"
        :cardIndex="cardIndex"
        :cardNumber="cardNumber"
        @close="showPopup = false"
      ></key-board>
    </mt-popup>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary
        :imgs="arrImgs"
        :curIndex="curIndex"
        v-show="showGallary"
        @close="showGallary=false"
      ></common-gallary>
    </fade-animation>
  </section>
</template>

<script>
import KeyBoard from './keyBoard';
import uploadimgSpaceup from '../../../components/uploadImgSpaceup';
import CommonGallary from "../../../components/Gallary";
import FadeAnimation from "../../../components/FadeAnimation";
import { loadParkHeaderById, spaceUpPcHttp } from '../../../utils/api';
import util from '../../../utils/util';
export default {
  props: {
    showUpLoadImg: {
      type: Boolean,
      default: true
    },
    parkingMess: {
      type: Object,
      default() { return {} }
    },
    oldTarget: {
      type: Number,
      default: 0
    },
    come: {
      type: String,
      default: ''
    },
    mustImg: {//是否必传图片 1是，2否
      type: Number,
      default: 2
    },
    applyData: {
      type: Object,
      default: () => { }
    },
    xuqianCardList: {
      type: Array,
      default() { return [] }
    },
    repeatCardList: {
      type: Array,
      default() { return [] }
    },
    repeatCardfileList:{
      type: Array,
      default() { return [] }
    }
  },
  components: {
    KeyBoard,
    uploadimgSpaceup,
    CommonGallary,
    FadeAnimation
  },
  data() {
    return {
      cardNumber: '',
      cardIndex: 0,
      showPopup: false,
      arrImgs: [],
      curIndex: 0,
      serverType: 2,
      showGallary: false,
      hex_md5_return: '',
      timemap: '',
      selectCardIndex: '',//判断是点击哪个车牌
      removeSomeUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/removeSomeAttachment',
      searchFileUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      oldTargetId: new Date().getTime(),
      cardfileList:[],
      // 车牌数据
      cardList: [
        {
          // fileList: [],
          // targetId: new Date().getTime(),
          cardNumber: ''
        }
      ]
    }
  },
  created() {
    let cardList = []
    if (this.xuqianCardList.length > 0) {
      this.resetSign()
      this.xuqianCardList.forEach((item, index) => {
        cardList.push({ fileList: [], targetId: 0, cardNumber: item.plateNo })
        // 获取车牌对应上传的图片
       
      })
      this.getImgs()
      this.cardList = cardList;
    }
    if (Object.keys(this.parkingMess).length > 0) {
      this.loadParkHeaderByIdAction();
    }
  },
  watch: {
    repeatCardList() {
      console.log("in repeatCardList  change")
      this.cardList = this.repeatCardList
      console.log( JSON.stringify(this.repeatCardList))
    },
    repeatCardfileList(){
        this.cardfileList = this.repeatCardfileList
        console.log("in repeatCardfileList  change")
        console.log( JSON.stringify(this.repeatCardfileList))
    },
    parkingMess() {
      console.log("in parkingMess  change")
      if (this.parkingMess) {
        this.loadParkHeaderByIdAction();
        this.cardList= [
          {
            // fileList: [],
            // targetId: new Date().getTime(),
            cardNumber: ''
          }
        ]
      }
    }
  },
  methods: {
    change() {

    },
    loadParkHeaderByIdAction() {
      let params = {
        //  parkLotId:this.curData.parkLotId,
        id: this.parkingMess.id,
        url: "/parking/rstParkHeader/loadParkHeaderById"
      }
      loadParkHeaderById(params).then(res => {
        // loadParkHeaderByIdAction(params).then(res=>{
        console.log(res)
        if (res.res && res.res.code === 10000) {
          this.serverType = res.body.data.serverType

        }
      })

    },
    // 换新方式获取附件 
    getImgs() {
       var id = this.applyData.id 
      fetch(this.searchFileUrl + "?moduleCode=TCP&target=" + id + "&platform=SaasMobile" + "&timestamp=" + this.timemap + "&sign=" + this.hex_md5_return + "&companyId=" + this.$store.state.common.marketInfo.cityId, {
        method: 'get',
        headers: {
          "Access-channel": "saas_rst"
        },
      }).then(response => response.json()).then(res => {
        console.log(res)
        if (res.code === 1000) {
          // this.cardList[index].fileList = res.data
          this.cardfileList =res.data
        }
      })
    },
    resetSign() {
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong + si + this.timemap + platfrom
      this.hex_md5_return = this.$md5(str)
    },
    viewImage(url, cardIndex, index) {
      // this.cardList[cardIndex].fileList
      this.cardfileList.forEach((item, i) => {
        // if(item.postfix.indexOf('image') > -1){
        this.$set(this.arrImgs, i, item.path)
        // }
      })
      this.curIndex = index
      this.showGallary = true
    },
    deleteFile(item, cardIndex, index) {
      let self = this;
      this.resetSign();
      util.showLoading('处理中...')
      fetch(self.removeSomeUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": this.$store.state.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'ids': item.id,
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': this.$store.state.common.marketInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log(res)
        util.hideLoading()
        // this.cardList[cardIndex].fileList
        this.cardfileList.splice(index, 1)
        this.$emit("inputChange", { data: this.cardfileList, type: 'cardfileList' })
      })
    },
    delectCardItem(index) {
      this.cardList.splice(index, 1)
      this.$emit("delectCardItem", { data: this.cardList, type: 'card' })
    },
    sureCardNumber(val) {
      this.showPopup = false;
      this.cardList[this.selectCardIndex].cardNumber = val
      this.$emit("inputChange", { data: this.cardList, type: 'card' })
    },
    showKeyBoard(cardIndex) {
      if (this.come == 'xuqian') { return false; }
      this.cardNumber = this.cardList[cardIndex].cardNumber;
      this.cardIndex = cardIndex;
      this.selectCardIndex = cardIndex;//判断是点击哪个车牌
      this.showPopup = true;
    },
    addCardNumber() {
      this.cardList.push(
        {
          fileList: [],
          // targetId: new Date().getTime(),
          // cardNumber: ''
        }
      )
    },
    uploadImgEnd(val) {
      let data = val.data;
      console.log('uploadImgEnd ' + JSON.stringify(data))
      // let index = val.index;
      // this.cardList.forEach((item, i) => {
      //   if (i == index) {
      //     item.fileList.push({ path: data.url, id: data.id })
      //   }
      // })
      this.cardfileList.push(
        { path: data.url, 
          targetId:data.target,
          id: data.id }
        )
      // this.$emit("inputChange", { data: this.cardList, type: 'card' })
      this.$emit("inputChange", { data: this.cardfileList, type: 'cardfileList' })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.card_box {
  background: hsl(0, 0%, 100%);
  padding: 0 20px;
  margin-bottom: 14px;
  position: relative;
  .delect_icon {
    width: 44px;
    height: 44px;
    position: absolute;
    top: 28px;
    right: 28px;
    z-index: 2;
  }
 
 
  .mess_list {
    background: #fff;
    border-bottom: 0.02rem solid #BDBDBD;
    .mess_list_item {
      position: relative;
      .flex();
      height: 100px;
      align-items: center;
      .list_item_left {
        width: 164px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fc3f56;
        }
      }
      .list_item_right {
        flex: 1;
        height: 100px;
        line-height: 100px;
        // .borderB();
        font-size: 30px;
        color: #333;
      }
      .placeholder {
        color: #c9c9c9;
      }
      .notclick {
        opacity: 0.6;
      }
    }
    .mess_list_item_3{
      // border-bottom:2px solid #BDBDBD ;
    }
  }

  
  h4 {
    font-size: 30px;
    color: rgba(51, 51, 51, 1);
    line-height: 42px;
    margin: 30px 0 10px;
    span {
      color: #fc3f56;
    }
  }
  .tips {
    font-size: 26px;
    color: rgba(153, 153, 153, 1);
    line-height: 36px;
    margin-bottom: 28px;
  }
}


.image_box{
  width: 694px;
  padding: 0 20px;
  background: #fff;
  background-color: #ffffff;
  margin-bottom: 14px;
  h4 {
    font-size: 30px;
    color: rgba(51, 51, 51, 1);
    line-height: 42px;
    margin-bottom: 10px;
    margin-top: 10px;
    span {
      color: #fc3f56;
    }
  }
  .tips {
    font-size: 26px;
    width: 694px;
    color: rgba(153, 153, 153, 1);
    line-height: 36px;
    margin-bottom: 28px;
  }
}
.card_felx{
  width: 100%;
  height: 10px;
  display: flex;
}
.card_felx1{
  width: 100%;
  display: flex;
  margin-bottom: 100px;

}
.pic {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 40px;
  .addPic {
    width: 160px;
    height: 160px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 28px;
    margin-right: 28px;
    .video_icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 68px;
      height: 68px;
    }
    .video {
      width: 160px;
      height: 160px;
    }
    .addImg {
      width: 28px;
      height: 28px;
    }
    .item_center_inp {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .file {
      position: absolute;
      width: 160px;
      height: 160px;
      opacity: 0;
    }
    .deleteFile {
      position: absolute;
      right: -25px;
      top: -25px;
      width: 50px;
      height: 50px;
    }
  }
}
// 添加车牌
.add_card {
  .flex();
  justify-content: flex-end;
  padding: 6px 20px 20px 0;
  .add_card_main {
    width: 200px;
    height: 68px;
    border-radius: 34px;
    background: #fff;
    .flex();
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    span {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>
